import React from 'react';
import {
  params,
  shape as shapeType,
  string,
  useDataModel,
  arrayOf as arrayType
} from '@thd-nucleus/data-sources';
import { arrayOf, shape, string as stringType } from 'prop-types';
import { Typography, Pill, Card } from '@one-thd/sui-atomic-components';
import { track } from './related-search-analytics';

const PopularCategories = ({ popCatId }) => {
  const {
    data,
    loading,
    error
  } = useDataModel('emtPopularCategories', {
    variables: {
      id: popCatId.length < 4 ? `0${popCatId}` : popCatId,
    }
  });

  const navigationList = data?.emtPopularCategories?.popularCategoryList;

  if (!data || loading || error) {
    return null;
  }

  return (
    <div className="popular-categories sui-w-full" data-component="PopularCategories">
      <Card
        className="sui-h-full sui-leading-none"
        style={{ background: 'transparent', borderStyle: 'none' }}
      >
        <Typography variant="h2" weight="display">Popular Categories</Typography>
        <PopularCategoriesList navigationList={navigationList} />
      </Card>
    </div>
  );
};

const PopularCategoriesList = ({
  navigationList
}) => {
  const handlePopularCategoryClick = (copyText) => {
    if (window?.LIFE_CYCLE_EVENT_BUS) {
      window.LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('popular-category.UPDATE', { updatedSearchTerm: '' });
    }
    track(copyText);
  };

  return (
    <div
      className="popular-categories__links sui-w-full sui-flex sui-flex-row sui-flex-wrap sui-leading-tight sui-gap-4"
    >
      {navigationList?.map((popCat, index) => {
        const url = popCat.paramLink;
        const copyText = popCat?.title;

        return (
          <div
            className="popular-categories__elements sui-bg-primary sui-rounded-full"
            key={`popcat-${copyText}${index}`}
          >
            <Pill
              label={copyText}
              component="a"
              href={url}
              onClick={() => handlePopularCategoryClick(copyText)}
              clickable
            />
          </div>
        );
      })}
    </div>
  );
};

PopularCategories.displayName = 'PopularCategories';

PopularCategories.propTypes = {
  popCatId: stringType.isRequired
};

PopularCategoriesList.propTypes = {
  navigationList: arrayOf(shape({}))
};

PopularCategoriesList.defaultProps = {
  navigationList: []
};

PopularCategories.dataModel = {
  emtPopularCategories: params({ id: string().isRequired() }).shape({
    popularCategoryList: arrayType(shapeType({
      title: string(),
      link: string(),
      paramLink: string()
    }))
  })
};

export { PopularCategories };
